// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Support, SupportStateType } from '../../../types/Model';
import ReadIcon from '../assets/read-flag.svg';
import TickIcon from '../../../assets/images/tick-icon-green.svg';
import S from './style';
import moment from 'moment';
interface SidebarListProps {
  currentId?: number;
  list?: Support[];
}
const SidebarList = (props: SidebarListProps): JSX.Element => {
  const intl = useIntl();
  const { list = [], currentId } = props;
  const now = new Date().getTime();
  const [isStatusClosed, setIsStatusClosed] = useState<boolean>(false);
  return (
    <S.SidebarWrapper {...props} >
      <S.HeaderSidebar><FormattedMessage id="I013" /></S.HeaderSidebar>
      <S.ListBox>
        {list.map(data => {
          const revisedTime = data.revisedTime ? new Date(data.revisedTime) : new Date(data.createdTime);
          return (
            <S.BoxItem key={data.id} open={currentId == data.id} as={Link} to={`/support?id=${data.id}`}>
              {!data.read && <S.Read src={ReadIcon} />}
              <S.ItemTitle open={currentId == data.id}>
                {data.title}
              </S.ItemTitle>
              <S.ItemTime>
                {now - revisedTime.getTime() <= 86400000 ? `${moment(revisedTime).fromNow(true)}` + intl.formatMessage({ id: 'I026' }) : moment(revisedTime).format('L')}
                {(data.supportStatus === SupportStateType.Closed) ? (
                  <S.Tag>
                    <S.Image src={TickIcon} />
                    已解決
                  </S.Tag>
                ) : ''}
              </S.ItemTime>
            </S.BoxItem>
          );
        })}
      </S.ListBox>
    </S.SidebarWrapper >
  );
}

export { SidebarList as default }
